/* eslint-disable */
import React from 'react'

import countBy from 'lodash/countBy'
import find from 'lodash/find'

import { pack, hierarchy } from 'd3-hierarchy'
import LoadCounts from './Helpers/LoadCounts'
import Color from '../../Utilities/Colors/ColorMap'

const connections = [
    ['00', '01'],
    ['00', '10'],
    ['01', '02'],
    ['02', '12'],
    ['01', '11'],
    ['10', '11'],
    ['10', '20'],
    ['11', '12'],
    ['11', '21'],
    ['12', '22'],
    ['22', '32'],
    ['20', '30'],
    ['20', '21'],
    ['30', '31'],
    ['21', '22'],
    ['21', '31'],
    ['31', '32'],
]

export default function CirclePack({ settings, chartOptions = {} }) {
    let counts = settings.data

    if (!chartOptions.skipDataProcess) {
        counts = LoadCounts(settings.data)
    }

    const layerCount = countBy(counts, 'layer')

    const layers = []
    const maxCircleSize = 75
    let scaleHeight = 0.24

    if (settings.shape === 'twitter') {
        scaleHeight = 0.34
    }
    // Array to store location of cx for connecting lines
    const xyLocations = []
    const cPack = (data) =>
        pack().size([maxCircleSize, maxCircleSize])(
            hierarchy(data)
                .sum((d) => d.value)
                .sort((a, b) => b.value - a.value)
        )

    const elements = []

    const scaleX = function (d) {
        const layer = d.layer.toString()

        if (!layers[layer] && layers[d.layer.toString()] != 0) {
            layers[layer] = 1
        } else {
            layers[layer]++
        }

        let widthCircle = settings.vizWidth / (layerCount[d.layer] + 1)
        widthCircle *= layers[layer]

        return widthCircle
    }

    counts.map((count) => {
        const root = cPack(count)
        const xLocation = scaleX(count)
        elements.push(
            <g
                key={`g_${count.name}`}
                transform={`translate(${xLocation}, ${
                    count.layer * (settings.height * scaleHeight)
                })`}
            >
                {root.descendants().map((parent, i) => {
                    if (!parent.parent) {
                        xyLocations.push({
                            layer: count.name,
                            x: xLocation + parent.x,
                            y:
                                count.layer * (settings.height * scaleHeight) +
                                parent.y,
                        })
                    }
                    return (
                        <React.Fragment key={`circlePack_${i}`}>
                            {!parent.parent ? (
                                <text
                                    x={maxCircleSize / 2}
                                    y={-maxCircleSize * 0.03}
                                    className="network-label-text"
                                >
                                    {count.balls}-{count.strikes}
                                </text>
                            ) : null}
                            <g
                                key={`parent_${count.layer}_${parent.data.name}`}
                                className={`${
                                    !parent.children
                                        ? ' node--leaf'
                                        : parent.depth
                                        ? ''
                                        : ' node--root'
                                }`}
                            >
                                <circle
                                    r={parent.r}
                                    stroke="#000"
                                    fill={
                                        parent.data.isPitch
                                            ? Color(
                                                  'pitchName',
                                                  parent.data.name
                                              )
                                            : '#fff'
                                    }
                                    cx={parent.x}
                                    cy={parent.y}
                                />
                            </g>
                        </React.Fragment>
                    )
                })}
            </g>
        )
    })

    connections.map((line, i) => {
        const lineStart = find(xyLocations, (d) => d.layer === line[0])
        const lineEnd = find(xyLocations, (d) => d.layer === line[1])

        elements.unshift(
            <g key={`connections_${i}`}>
                <line
                    x1={lineStart.x}
                    y1={lineStart.y}
                    x2={lineEnd.x}
                    y2={lineEnd.y}
                    stroke="#000"
                    strokeWidth={2}
                />
            </g>
        )
    })

    return <g id="network">{elements}</g>
}
